module.exports = __webpack_public_path__ + "img/5.125a12bd.png";